import request from 'request/index'
import { E_PRODUCT2_RES } from 'utils/config'
export default {
  /**
    *  3.1.3.1 获取历史版本列表 [get] /visitor/product/app/{app_id}/history?$count=false&$offset=偏移量&$limit=数量
    */
  sGetHistory ({
    app_id,
    $count = true,
    $offset = 0,
    $limit = 10
  }) {
    return request({
      method: 'GET',
      res: E_PRODUCT2_RES,
      api: '/visitor/product/app/{app_id}/history',
      params: {
        app_id
      },
      query: {
        $count,
        $limit,
        $offset
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/apis/edmodo/history.js